// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_kSA","cls2":"Comments-cls2_PD1 Comments-cls1_kSA"};